import React from "react";
import { Text } from "flicket-ui";

export const Badge = ({ children }) => (
  <Text
    style={{
      padding: "4px 8px",
      backgroundColor: "#DC3009",
    }}
    variant="small"
    borderRadius="full"
    // backgroundColor="error"
    fontSize={1}
    display="inline-block"
    whiteSpace="nowrap"
    lineHeight="normal"
    color="white"
    mr={1}
    fontStyle="italic"
  >
    {children}
  </Text>
);
